<p-card>
  <ng-template pTemplate="header">
    <div class="px-4 pt-4">
      <h2 class="text-lg font-semibold">Structure d'équipement</h2>
      <p class="text-sm text-gray-500 mt-1">
        Importez un fichier Excel pour synchroniser la structure d'équipement
        SAP (Usines, Groupes de planification, Centres de charge, Localisations
        fonctionnelles).
      </p>
    </div>
  </ng-template>

  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-3">
      <p-fileUpload
        mode="basic"
        accept=".xlsx,.xls"
        chooseLabel="Choisir un fichier Excel"
        [auto]="false"
        [customUpload]="true"
        (onSelect)="onFileSelected($event)"
        styleClass="p-button-outlined"
      ></p-fileUpload>

      <span *ngIf="importFile" class="text-sm text-gray-600">
        {{ importFile.name }}
      </span>

      <p-button
        label="Importer"
        icon="pi pi-upload"
        [disabled]="!importFile || isImporting"
        [loading]="isImporting"
        (onClick)="onImport()"
      ></p-button>
    </div>

    <p-message
      *ngIf="importError"
      severity="error"
      [text]="importError"
    ></p-message>

    <div *ngIf="importResult">
      <p-message
        *ngIf="importResult.errors.length === 0"
        severity="success"
        text="Importation terminée avec succès."
      ></p-message>
      <p-message
        *ngIf="importResult.errors.length > 0"
        severity="warn"
        text="Importation terminée avec des avertissements."
      ></p-message>

      <p-table
        [value]="[
          {
            entity: 'Usines (Plants)',
            created: importResult.plantsCreated,
            updated: importResult.plantsUpdated,
            deleted: importResult.plantsDeleted,
            skipped: importResult.plantsSkippedDeletion,
          },
          {
            entity: 'Groupes de planification',
            created: importResult.plannerGroupsCreated,
            updated: importResult.plannerGroupsUpdated,
            deleted: importResult.plannerGroupsDeleted,
            skipped: importResult.plannerGroupsSkippedDeletion,
          },
          {
            entity: 'Centres de charge',
            created: importResult.workCentersCreated,
            updated: importResult.workCentersUpdated,
            deleted: importResult.workCentersDeleted,
            skipped: importResult.workCentersSkippedDeletion,
          },
          {
            entity: 'Localisations fonctionnelles',
            created: importResult.functionalLocationsCreated,
            updated: importResult.functionalLocationsUpdated,
            deleted: importResult.functionalLocationsDeleted,
            skipped: importResult.functionalLocationsSkippedDeletion,
          },
        ]"
        styleClass="p-datatable-sm mt-3"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Entité</th>
            <th>Créées</th>
            <th>Mises à jour</th>
            <th>Supprimées</th>
            <th>Suppression ignorée (règles)</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.entity }}</td>
            <td>{{ row.created }}</td>
            <td>{{ row.updated }}</td>
            <td>{{ row.deleted }}</td>
            <td>{{ row.skipped }}</td>
          </tr>
        </ng-template>
      </p-table>

      <div *ngIf="importResult.errors.length > 0" class="mt-3">
        <p class="text-sm font-semibold text-orange-600 mb-1">
          Avertissements :
        </p>
        <ul class="text-sm text-gray-700 list-disc pl-5">
          <li *ngFor="let err of importResult.errors">{{ err }}</li>
        </ul>
      </div>
    </div>
  </div>
</p-card>
